export const CONFIG_FORM = "config_form";
